"use client";
import { useEffect, startTransition } from 'react';
import Image from 'next/image';
import Splide from "@splidejs/splide";

interface ClientCarouselProps {
    clients: any[];
}

export const ClientCarousel = ({ clients }: ClientCarouselProps) => {
    useEffect(() => {
        startTransition(() => {
            let s = new Splide('.client_carousel', {
                autoplay: true,
                type: 'loop',
                perPage: 7,
                perMove: 7,
                start: 0,
                arrows: false,
                interval: 4000,
                speed: 1800,
                breakpoints: {
                    2200: { perPage: 5, perMove: 5 },
                    1600: { perPage: 4, perMove: 4 },
                    1200: { perPage: 3, perMove: 3 },
                    800: { perPage: 2, perMove: 2 },
                    640: { perPage: 1, perMove: 1 }
                }
            });
            s.mount();
        });
    }, []);

    return (
        <div className="flex flex-col sm:mx-4 justify-center py-regular sm:py-taller">
            <div className="flex flex-col items-center justify-center">
                <h2 className="text-center font-bold py-5 text-gcopper text-5xl font-roboto-condensed">You're in Trusted Hands</h2>
                <div className="text-center px-8 text-xl font-roboto-condensed">
                    There's no size or complexity we can't handle as we roll through one monumental project after another, year after year.<br />
                    Look at the household names we've navigated seamlessly through massive transitions and rapid growth.
                </div>
            </div>
            <div className="client_carousel splide text-center py-10 mx-auto px-10 max-w-427.5">
                <div className="splide__track">
                    <div className="splide__list">
                        {
                            clients.map((client, i) => {
                                return <div key={i} className="splide__slide">
                                    <Image
                                        loading="lazy"
                                        className="h-35 w-auto m-auto"
                                        src={client.logoRectangle.src}
                                        alt="client"
                                        height={150}
                                        width={175}
                                    />
                                </div>;
                            })
                        }
                    </div>
                </div>
            </div>
        </div>);
};

export default ClientCarousel;